import { apiFetch } from './client'
import type { OnboardingStatus, ChatMessage, ChatResponse } from './types'

export const onboardingApi = {
  getStatus: (token: string, customerId: string) =>
    apiFetch<OnboardingStatus>(`/onboarding/${customerId}/status`, token),

  storeCredentials: (
    token: string,
    data: { customer_id: string; tenant_id: string; client_id: string; client_secret: string },
  ) => apiFetch<{ ok: boolean; prefix: string }>('/onboarding/credentials', token, {
    method: 'POST',
    body: JSON.stringify(data),
  }),

  chat: (token: string, customerId: string, messages: ChatMessage[]) =>
    apiFetch<ChatResponse>('/onboarding/chat', token, {
      method: 'POST',
      body: JSON.stringify({ customer_id: customerId, messages }),
    }),
}
